<template>
  <rate-plan-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processRatePlanForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateRatePlan } from '@/services/rate_plan.service'
import ratePlanBlankForm from '@/components/forms/rate_plan/RatePlanBlankForm'

export default {
  name: 'rate-plan-edit-form',
  components: { ratePlanBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        rate_plan: {
          id: [],
          name: [],
          amount: [],
          period: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processRatePlanForm () {
      this.updateRatePlan().then((success) => {
        if (success) {
          this.showMsg('Информация была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateRatePlan () {
      return updateRatePlan(this.$attrs['rate-plan']).then((response) => {
        this.fillErrors(this.errors.rate_plan, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.rate_plan, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// RatePlanEditForm.vue?3189a5f9